import React, { useState, useEffect } from 'react'
import { Button, TextField } from '@mui/material'
import { toast } from 'react-toastify'
import { BACKEND_URI } from '../config'


function InviteCodes( user ) {
  const [inviteCodes, setInviteCodes] = useState({})
  const [searchTerm, setSearchTerm] = useState('')
  const [filteredCodes, setFilteredCodes] = useState(inviteCodes)
  const [areYouSureDeleteButtonVisible, setareYouSureDeleteButtonVisible] =
    useState(false)
  const [deleteButtonShown, setDeleteButtonShown] = useState()
  const [customInviteCode, setCustomInviteCode] = useState('')
  const [numOfUses, setNumOfUses] = useState()
  const [creatingInviteCode, setCreatingInviteCode] = useState(false)

  // Handle search input change
  const handleSearch = e => {
    const term = e.target.value.toLowerCase()
    setSearchTerm(term)
    filterCodes(term)
  }

  function filterCodes(term, invite_codes) {
    let CodesTemp = ''
    if (invite_codes) {
      CodesTemp = invite_codes
    } else {
      CodesTemp = inviteCodes
    }

    if (term === '') {
      setFilteredCodes(CodesTemp)
    } else {
      const filtered = CodesTemp.filter(codeTemp => {
        const matchesSearch =
          codeTemp.code.toLowerCase().includes(term.toLowerCase()) ||
          codeTemp.uses.toString().includes(term) ||
          codeTemp.createdBy.toLowerCase().includes(term.toLowerCase())

        return matchesSearch
      })
      setFilteredCodes(filtered)
    }
  }

  useEffect(() => {
    const fetchInviteCodes = async () => {
      try {
        const token = localStorage.getItem('token')
        const response = await fetch(`${BACKEND_URI}/api/invite-codes`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })

        const data = await response.json()

        setInviteCodes(data)
        filterCodes('', data)
      } catch (error) {
        console.error('Error fetching user information:', error)
      }
    }

    fetchInviteCodes()
  }, [])

  const handleDeleteCode = async code => {
    try {
      const token = localStorage.getItem('token') // JWT for authentication
      const response = await fetch(`${BACKEND_URI}/api/delete-code`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ code }),
      })

      const data = await response.json()

      if (!response.ok) {
        throw new Error(data.error || 'Failed to delete code')
      }

      const updatedCodes = inviteCodes.filter(c => c.code !== code)

      // Update the state with the new codes
      setInviteCodes(updatedCodes)
      filterCodes(searchTerm, updatedCodes)
      setareYouSureDeleteButtonVisible(false)

      toast.success('Successfully deleted code')
    } catch (err) {
      console.error('Error deleting code:', err)
      toast.error(err.message || 'Error deleting code.')
    }
  }

  const handleGenerateInviteCode = async () => {
    if (!customInviteCode.trim() || (numOfUses && numOfUses <= 0)) {
      toast.error('Please enter a valid invite code and a valid number of uses.')
      return
    }

    try {
      const token = localStorage.getItem('token') // JWT for authentication
      const response = await fetch(
        `${BACKEND_URI}/api/generate-invite-code`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            code: customInviteCode,
            uses: parseFloat(numOfUses),
          }), // Send custom invite code
        }
      )

      const data = await response.json()

      if (!response.ok) {
        throw new Error(data.error || 'Failed to create invite code')
      }

      const newCode = {code: customInviteCode, uses: parseFloat(numOfUses), createdBy: user.username}

      setInviteCodes((prev) => [...prev, newCode])

      toast.success(`Invite code created: ${data.code}`)
      setCustomInviteCode('') // Clear the input field
      setNumOfUses()
      setCreatingInviteCode(false)
    } catch (err) {
      console.error('Error creating invite code:', err)
      toast.error(err.message || 'Error creating invite code.')
    }
  }

  return (
    <div
      style={{
        padding: '20px',
        border: '1px solid #ddd',
        borderRadius: '10px',
        backgroundColor: '#f9f9f9',
      }}
    >
      {/* create invite code section */}
      {creatingInviteCode && (
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <label style={{ marginBottom: '5px' }}>Cusom Invite Code</label>
          <TextField
            label='Enter Custom Invite Code'
            value={customInviteCode}
            onChange={e => setCustomInviteCode(e.target.value)}
            size='small'
            // fullWidth
            style={{ marginBottom: '10px' }}
          />
          <label style={{ marginBottom: '5px' }}>Number of Uses</label>
          <TextField
            label='Enter number of uses'
            type='number'
            value={numOfUses}
            onChange={e => setNumOfUses(e.target.value)}
            size='small'
            // fullWidth
            style={{ marginBottom: '10px' }}
          ></TextField>
          <Button
            onClick={handleGenerateInviteCode}
            variant='contained'
            // color="primary"
            style={{ marginBottom: '10px', backgroundColor: '#51a4ac' }}
          >
            Create Invite Code
          </Button>
          <div />
          <Button
            onClick={e => setCreatingInviteCode(false)}
            variant='contained'
            // color="error"
            style={{ backgroundColor: '#c53b3a' }}
          >
            Cancel
          </Button>
        </div>
      )}

      {!creatingInviteCode && (
        <>
          <h2>Invite Codes</h2>
          <input
            type='text'
            placeholder='Search by code, uses remaining, or created by'
            value={searchTerm}
            onChange={handleSearch}
            style={{
              padding: '10px',
              width: '100%',
              borderRadius: '5px',
              border: '1px solid #ccc',
              marginBottom: '5px',
            }}
          />
          <Button
            onClick={e => setCreatingInviteCode(true)}
            variant='contained'
            // color="primary"
            style={{ marginBottom: '20px', backgroundColor: '#51a4ac' }}
          >
            Create Invite Code
          </Button>

          {filteredCodes.length > 0 ? (
            filteredCodes.map((code, idx) => (
              <div
                key={code._id}
                style={{
                  marginBottom: '20px',
                  padding: '10px',
                  border: '1px solid #ccc',
                  borderRadius: '5px',
                }}
              >
                <p>
                  <strong>Code:</strong> {code.code}
                </p>
                <p>
                  <strong>Uses Remaining:</strong> {code.uses}
                </p>
                <p>
                  <strong>Created By:</strong> {code.createdBy}
                </p>

                <button
                  onClick={e => {
                    setareYouSureDeleteButtonVisible(true)
                    setDeleteButtonShown(idx)
                  }}
                  style={
                    areYouSureDeleteButtonVisible && deleteButtonShown === idx
                      ? styles.buttonDisabled
                      : styles.cancelButton
                  }
                >
                  Delete
                </button>
                <div />
                {areYouSureDeleteButtonVisible && deleteButtonShown === idx && (
                  <div style={{ marginTop: '.5rem', marginBottom: '.5rem' }}>
                    <label>Are you sure you want to delete this code?</label>
                    <div />
                    <button
                      style={styles.saveButton}
                      onClick={e => handleDeleteCode(code.code)}
                    >
                      Yes
                    </button>
                    <button
                      style={styles.cancelButton}
                      onClick={e => setareYouSureDeleteButtonVisible(false)}
                    >
                      No
                    </button>
                  </div>
                )}
              </div>
            ))
          ) : (
            <p>No Invite Codes found.</p>
          )}
        </>
      )}
    </div>
  )
}

const styles = {
  buttonDisabled: {
    backgroundColor: 'grey',
    color: 'white',
    border: 'none',
    padding: '0.5rem 1rem',
    borderRadius: '4px',
    fontSize: '0.9rem',
  },
  saveButton: {
    padding: '0.5rem 1rem',
    backgroundColor: 'green',
    color: '#fff',
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer',
    marginRight: '0.5rem',
  },
  cancelButton: {
    padding: '0.5rem 1rem',
    backgroundColor: '#c53b3a',
    color: '#fff',
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer',
  },
}

export default InviteCodes
